import algoliasearch from "algoliasearch"
import React, { useRef } from "react"
import Form from "react-bootstrap/Form"
import { useTranslation } from "react-i18next"
import { InstantSearch } from "react-instantsearch-dom"

import CustomInfiniteHits from "./CustomInfiniteHits"
import CustomSearchBox from "./CustomSearchBox"
import CustomStateResults from "./CustomStateResults"
import Hit from "./Hit"

const algoliaClient = algoliasearch(
  process.env.GATSBY_ALGOLIA_APP_ID,
  process.env.GATSBY_ALGOLIA_SEARCH_KEY
)

const searchClient = {
  search(requests) {
    if (requests[0].params.query.length) {
      return algoliaClient.search(requests)
    } else {
      return Promise.resolve({
        results: [
          {
            hits: [],
            nbHits: 0,
            nbPages: 0,
            page: 0,
            processingTimeMS: 0,
          },
        ],
      })
    }
  },
}

const FormSearch = ({ currentLanguage }) => {
  const indexName = `almatalent_i_production_${currentLanguage}`

  const { t } = useTranslation()

  const resultsRef = useRef(null)

  const onSearchSubmit = (event) => {
    event.preventDefault()
    if (resultsRef.current) {
      resultsRef.current.focus()
    }
  }

  return (
    <>
      <Form
        className="form form-alt max-vw"
        role="search"
        onSubmit={onSearchSubmit}
      >
        <Form.Group>
          <Form.Label
            htmlFor="site_search"
            className="big-label screen-reader-text"
          >
            {t("Search ")}
          </Form.Label>
          <InstantSearch searchClient={searchClient} indexName={indexName}>
            <CustomSearchBox />
            <CustomStateResults resultsRef={resultsRef} />
            <CustomInfiniteHits hitComponent={Hit} />
          </InstantSearch>
        </Form.Group>
      </Form>
    </>
  )
}

export default FormSearch
